import { getItem } from "./LocalStorage";
import { INT_FLOAT_REGEX, INT_REGEX } from "../constants/regex";

// "L" | "hL" — scelta esplicita dell'utente; nessun AUTO.
// hL <=> l'utente ha selezionato hL; in ogni altro caso => L.
export const getTankUnit = () => (getItem("tankUnit") === "hL" ? "hL" : "L");

// Unità scelta dall'utente, anche su un browser che non l'ha ancora memorizzata:
// prima la scelta salvata nel browser (aggiornata appena la cambia in UserCustomization),
// poi quella nelle impostazioni dell'utente (user.settings.tank_unit), altrimenti L.
export const resolveTankUnit = (userSettingUnit) => {
  const stored = getItem("tankUnit");
  if (stored === "L" || stored === "hL") return stored;
  return userSettingUnit === "hL" ? "hL" : "L";
};

// Unità DEGLI INPUT (litri da spostare): identica alla preferenza di visualizzazione.
export const getInputTankUnit = getTankUnit;

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// litri (backend) -> valore mostrato nell'input
export const litersToInput = (liters, unit = getInputTankUnit()) =>
  unit === "hL" ? round2(liters / 100) : Number(liters) || 0;

// valore input -> litri (per payload e per la matematica in litri).
// Math.round perché il BE vuole litri interi e per evitare 9.55*100 = 955.0000001
export const inputToLiters = (value, unit = getInputTankUnit()) =>
  unit === "hL" ? Math.round((Number(value) || 0) * 100) : Number(value) || 0;

// Regex/min coerenti con l'unità: in hL servono i decimali, in L interi positivi.
export const getInputQtyRegex = (unit = getInputTankUnit()) =>
  unit === "hL" ? INT_FLOAT_REGEX : INT_REGEX;

export const getInputQtyMin = (unit = getInputTankUnit()) =>
  unit === "hL" ? 0.01 : 1;

// Decide L vs hL: hL solo se l'utente ha scelto esplicitamente hL.
export const formatTankUnit = (quantity, capacity, tankUnit = getTankUnit()) => {
  const q = Number(quantity) || 0;
  const c = Number(capacity) || 0;
  const useHL = tankUnit === "hL";
  return {
    displayedQuantity: useHL ? Math.round(q / 100) : Math.round(q),
    displayedCapacity: useHL ? Math.round(c / 100) : Math.round(c),
    unit: useHL ? "hL" : "L",
  };
};

// Etichetta per una quantità "delta/arrow" (in litri) nell'unità di
// visualizzazione (L/hL), mantenendo i decimali in hL (a differenza di
// formatTankUnit che arrotonda all'intero). NON usare per masse in Kg
// (uva/vinacce): quelle restano sempre in Kg.
export const formatArrowQuantity = (liters, unit = getTankUnit()) => ({
  value: litersToInput(liters, unit),
  unit,
});

export const tankOccupancy = (quantity, capacity) =>
  Number(capacity) > 0
    ? Math.round((Number(quantity) * 100) / Number(capacity))
    : 0;
